__turbopack_context__.v({
  "ChildList": "Tag-module-scss-module__XZ6veW__ChildList",
  "List": "Tag-module-scss-module__XZ6veW__List",
  "More": "Tag-module-scss-module__XZ6veW__More",
  "Tag": "Tag-module-scss-module__XZ6veW__Tag",
  "Tags": "Tag-module-scss-module__XZ6veW__Tags",
});
